/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import { compact, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class AnalysisRoute extends Route {
  // Services
  @service
  store;

  model() {
    let post = this.modelFor('people.person.post');
    let model = {
      post,
      notificationResults: this.store.query('notifications/result', {
        entityId: post.id,
      }),
    };
    let caregiverIds = compact(
      mapBy(post.get('person.learner.primaryContacts'), 'caregiverId'),
    );
    if (caregiverIds.length > 0) {
      model.caregivers = this.store.query('person', {
        people: JSON.stringify(caregiverIds),
      });
    }
    return hash(model);
  }
}
